import AppStore from './AppStore';

export * from './AppConfigContext';
export * from './toolMeta';
export type * from './types';
export * from './utils';

const appStore = new AppStore();

export default appStore;
